// this is an autogenerated file from DesignSystem/SendPatientMessage/query-person-by-id.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_SendPatientMessage($id: uuid!) {
  vaxiom_persons(where: { _id: { _eq: $id } }) {
    id
  }
}

`